import { LazyLoadImage } from 'react-lazy-load-image-component';

// Import helpers
import { importIcon } from 'helpers/images';

type Props = {
	icon: string;
	width?: number;
	height?: number;
	alt: string;
};

const DynamicIcon = ({ icon, width, height, alt }: Props) => {
	if (!icon) return null;
	const src = importIcon(icon);

	return <LazyLoadImage height={height} width={width} src={src} alt={alt} />;
};

export default DynamicIcon;
